import { usePage } from '@inertiajs/vue3'
import { NAV_ITEMS } from '@/navigation'

function matches(url: string, href: string): boolean {
  return url === href || url.startsWith(href + '/') || url.startsWith(href + '?')
}

export function isActive(href: string): boolean {
  const url = usePage().url ?? ''
  if (!matches(url, href)) return false
  const moreSpecific = NAV_ITEMS.some(
    (item) => item.href !== href && item.href.length > href.length && matches(url, item.href),
  )
  return !moreSpecific
}

// Активен ли хоть один пункт группы — нужно там, где сама группа свёрнута в кнопку
// («Ещё» в таб-баре, «Управление ▾» в шапке): иначе пользователь не видит, где он.
export function isAnyActive(items: { href: string }[]): boolean {
  return items.some((item) => isActive(item.href))
}
